/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// const profotoProducts = new Set([
//   90020010, 90040010, 90010010, 90030010, 90050010, 80111030,
// ]);

/**
 * Profoto Mutation Observer
 * @author @ayodyln
 * @version 1.0
 * @description This script is used to observe the changes in the Klevu search results and Hides the Profoto Products from the Search Element.
 */
// function observeKlevuSearchResults() {
//   const klevuElement = document.querySelector(".klevuSearchResults-l2"); // Klevu Search Results Element
//   if (!klevuElement) {
//     setTimeout(observeKlevuSearchResults, 1000); // Retry after 1 second
//     return;
//   }
//   const config = { attributes: false, childList: true, subtree: true };
//   const observer = new MutationObserver((mutationsList, observer) => {
//     for (const mutation of mutationsList) {
//       if (mutation.type === "childList") {
//         // Loop through added nodes in the mutation
//         mutation.addedNodes.forEach((node) => {
//           node.childNodes.forEach((child) => {
//             const description = child.querySelector(
//               ".klevu-name-desc-l2 > .klevu-name-l2 > span"
//             );
//             const price = child.querySelector(
//               ".klevu-name-desc-l2 > .klevu-price-l2"
//             );
//             const sku = parseInt(description.textContent.replace(/[()]/g, ""));
//             const isProfotoProduct = profotoProducts.has(sku);
//             if (isProfotoProduct) {
//               price.remove();
//             }
//           });
//         });
//       }
//     }
//   });
//   observer.observe(klevuElement, config);
// }

/**
 * Klevu Search Results Observer
 * @author @ayodyln
 * @version 1.0
 * @description This script is used to observe the Klevu Search Results Page and log the current URL.
 */
// function klevuSearchResultsObserver() {
//   if (window.location.pathname !== "/pages/search-results") return;

//   const filters = document.querySelector(".kuFilters");
//   const resultsView = document.getElementById("kuResultsView");

//   if (resultsView && filters) {
//     const config = { attributes: false, childList: true, subtree: false };

//     const observer = new MutationObserver((mutationsList, observer) => {
//       const rangefilter = document.querySelector("#kuFilterBox-Price-Range");
//       const searchContainsProfoto = /\b(profoto|styleshoots|product)\b/.test(
//         window.location.search.toLowerCase()
//       );

//       if (searchContainsProfoto) {
//         rangefilter.remove();
//       }

//       for (const mutation of mutationsList) {
//         if (mutation.type === "childList") {
//           mutation.addedNodes.forEach((node) =>
//             node.childNodes.forEach((child) => {
//               const kuNameDesc = parseInt(
//                 child
//                   .querySelector(".kuNameDesc > .kuName > a span")
//                   .textContent.replace(/[()]/g, "")
//               );

//               const price = child.querySelector(".kuPrice");
//               const isProfotoProduct = profotoProducts.has(kuNameDesc);
//               if (isProfotoProduct) {
//                 price.remove();
//               }
//             })
//           );

//           klevuULObserver(
//             observer,
//             mutation.addedNodes.entries().find((entry) => {
//               if (entry[1].tagName === "UL") return entry[1];
//             })
//           );
//         }
//       }
//     });

//     observer.observe(resultsView, config);
//   }
// }

/**
 * Klevu UL Observer
 * @description This function is used to observe the UL post DOM Content Loaded ~ List Items are added on Scroll
 * @param {MutationObserver} initialObserver - Initial Mutation Observer
 * @param {Array} ul - UL Element
 */
// function klevuULObserver(initialObserver, ul) {
//   initialObserver.disconnect();
//   const [_, node] = ul;
//   const config = { attributes: false, childList: true, subtree: true };
//   const observer = new MutationObserver((mutationsList, observer) => {
//     for (const mutation of mutationsList) {
//       if (mutation.type === "childList") {
//         mutation.addedNodes.forEach((node) => {
//           const kuNameDesc = parseInt(
//             node
//               .querySelector(".kuNameDesc > .kuName > a > span")
//               .textContent.replace(/[()]/g, "")
//           );
//           const price = node.querySelector(".kuPrice");
//           const isProfotoProduct = profotoProducts.has(kuNameDesc);
//           if (isProfotoProduct) price?.remove();
//         });
//       }
//     }
//   });
//   observer.observe(node, config);
// }

// Wait for the DOM to be ready
// document.addEventListener("DOMContentLoaded", () => {
//   observeKlevuSearchResults(); // Start observing the Klevu Search Results
//   klevuSearchResultsObserver(); // Start observing the Klevu Search Results Page
// });

/**
 * Location Stock Availability Handler
 * Updates location stock display when variant changes on product page
 */
(function() {
  'use strict';

  function updateLocationStock(variantId) {
    const locationStockContainer = document.querySelector('.location-stock-availability[data-variant-id="' + variantId + '"]');
    
    if (!locationStockContainer) {
      // If container doesn't exist for this variant, fetch it from the server
      fetch(window.Shopify.routes.root + 'variants/' + variantId + '?section_id=store-availability')
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newLocationStock = doc.querySelector('.location-stock-availability');
          
          if (newLocationStock) {
            // Only update collection page location stock, not product page (product page renders it inline with stock status)
            const existingContainer = document.querySelector('.product-item__location-stock');
            if (existingContainer) {
              existingContainer.innerHTML = newLocationStock.outerHTML;
            }
            // Don't update product-meta__location-stock as it's no longer used on product pages
          }
        })
        .catch(error => {
          console.error('Error updating location stock:', error);
        });
    }
  }

  // Listen for variant changes
  document.addEventListener('variant:changed', function(event) {
    const variant = event.detail.variant;
    if (variant && variant.id) {
      updateLocationStock(variant.id);
    }
  });

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', function() {
    // The modal functionality is already handled by theme.js via data-action attributes
    // No additional initialization needed
  });
})();

(function () {
  'use strict';

  var targetPath = '/products/trade-in-event-at-photox-outdoor-may-15-16th-2026';
  var storageKey = 'pictureline:photox-outdoor-product-trade-in-popup:v1';

  if (window.location.pathname !== targetPath) {
    return;
  }

  function ensureTradeInEventPopup() {
    var existingPopups = document.querySelectorAll('[data-pline-tradein-event-popup]');
    if (existingPopups.length > 0) {
      existingPopups.forEach(function (popup, index) {
        if (index > 0 && popup.parentNode) {
          popup.parentNode.removeChild(popup);
        }
      });

      return existingPopups[0];
    }

    var style = document.createElement('style');
    style.textContent = [
      '.pline-tradein-event-popup[hidden]{display:none!important;}',
      '.pline-tradein-event-popup{align-items:center;display:flex;inset:0;justify-content:center;padding:20px;position:fixed;z-index:99999;}',
      '.pline-tradein-event-popup__backdrop{background:rgba(0,0,0,.58);inset:0;position:absolute;}',
      '.pline-tradein-event-popup__dialog{background:#fff;border-radius:8px;box-shadow:0 24px 70px rgba(0,0,0,.28);max-width:520px;padding:32px;position:relative;width:min(100%,520px);}',
      '.pline-tradein-event-popup__close{align-items:center;background:transparent;border:0;color:#333;cursor:pointer;display:flex;font-size:32px;height:40px;justify-content:center;line-height:1;padding:0;position:absolute;right:12px;top:10px;width:40px;}',
      '.pline-tradein-event-popup__close:hover{color:#b83a3a;}',
      '.pline-tradein-event-popup__eyebrow{color:#b83a3a;font-size:12px;font-weight:800;letter-spacing:.08em;margin:0 40px 10px 0;text-transform:uppercase;}',
      '.pline-tradein-event-popup__dialog h2{color:#303030;font-size:30px;line-height:1.15;margin:0 0 14px;}',
      '.pline-tradein-event-popup__dialog p{color:#4b4b4b;font-size:16px;line-height:1.55;margin:0;}',
      '.pline-tradein-event-popup__actions{display:flex;flex-wrap:wrap;gap:12px;margin-top:24px;}',
      '.pline-tradein-event-popup__actions .button{flex:1 1 180px;margin:0;max-width:none;text-align:center;}',
      '.pline-tradein-event-popup__secondary{background:#fff;border:1px solid #b83a3a;border-radius:5px;color:#b83a3a;}',
      '.pline-tradein-event-popup__secondary:hover{background:#b83a3a;color:#fff;}',
      'html.pline-tradein-event-popup-open{overflow:hidden;}',
      '@media (max-width:480px){.pline-tradein-event-popup{align-items:flex-end;padding:14px;}.pline-tradein-event-popup__dialog{padding:26px 20px 20px;}.pline-tradein-event-popup__dialog h2{font-size:24px;}}'
    ].join('');
    document.head.appendChild(style);

    var wrapper = document.createElement('div');
    wrapper.innerHTML = [
      '<div class="pline-tradein-event-popup" data-pline-tradein-event-popup hidden aria-hidden="true">',
      '<div class="pline-tradein-event-popup__backdrop" data-pline-tradein-event-close></div>',
      '<section class="pline-tradein-event-popup__dialog" role="dialog" aria-modal="true" aria-labelledby="pline-tradein-event-popup-title" aria-describedby="pline-tradein-event-popup-description">',
      '<button class="pline-tradein-event-popup__close" type="button" data-pline-tradein-event-close aria-label="Close trade-in popup">&times;</button>',
      '<p class="pline-tradein-event-popup__eyebrow">PhotoX Outdoor Trade-In Event</p>',
      '<h2 id="pline-tradein-event-popup-title">Start your PhotoX Outdoor trade-in</h2>',
      '<p id="pline-tradein-event-popup-description">Bring your used camera gear to PhotoX Outdoor and get the process started now. Submit your trade-in before the event so our team can review your gear details.</p>',
      '<div class="pline-tradein-event-popup__actions">',
      '<a class="button button--primary" href="https://trades.pictureline.com/events/public/photox-outdoor-may-2026" data-pline-tradein-event-start>Start Trade-In</a>',
      '<button class="button pline-tradein-event-popup__secondary" type="button" data-pline-tradein-event-close>Not now</button>',
      '</div>',
      '</section>',
      '</div>'
    ].join('');
    var popup = wrapper.firstElementChild;
    document.body.appendChild(popup);
    return popup;
  }

  function initTradeInEventPopup() {
    var popup = ensureTradeInEventPopup();
    var startLink = popup.querySelector('[data-pline-tradein-event-start]');
    var closeButtons = popup.querySelectorAll('[data-pline-tradein-event-close]');
    var canUseStorage = true;

    try {
      window.localStorage.setItem(storageKey + ':test', '1');
      window.localStorage.removeItem(storageKey + ':test');
    } catch (error) {
      canUseStorage = false;
    }

    function hasDismissed() {
      return canUseStorage && window.localStorage.getItem(storageKey) === 'dismissed';
    }

    function markDismissed() {
      if (canUseStorage) {
        window.localStorage.setItem(storageKey, 'dismissed');
      }
    }

    function closePopup() {
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('pline-tradein-event-popup-open');
      markDismissed();
    }

    function openPopup() {
      if (hasDismissed()) return;
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('pline-tradein-event-popup-open');
      window.requestAnimationFrame(function () {
        if (startLink) startLink.focus();
      });
    }

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closePopup);
    });

    if (startLink) {
      startLink.addEventListener('click', markDismissed);
    }

    document.addEventListener('keydown', function (event) {
      if (!popup.hidden && event.key === 'Escape') {
        closePopup();
      }
    });

    window.setTimeout(openPopup, 700);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTradeInEventPopup);
  } else {
    initTradeInEventPopup();
  }
})();
